export default __webpack_public_path__ + "/images/palm-trees.jpg";